import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";

import { getIsEdit } from "../../store/modules/display/selectors";
import { hasActiveRecord } from "../../store/modules/library/selectors";
import { setIsEdit } from "../../store/modules/display/actions";

export const useToggleEdit = () => {
  const dispatch = useDispatch();
  const isEdit = useSelector(getIsEdit);
  const canEdit = useSelector(hasActiveRecord);
  const toggleIsEdit = useCallback(() => {
    if (canEdit) {
      dispatch(setIsEdit(!isEdit));
    } else {
      toastr.warning("Edit Record", "Active Record does not exist.");
    }
  }, [isEdit, canEdit, dispatch]);

  return ({
    isEdit,
    canEdit,
    toggleIsEdit,
  });
};
